import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function CustomerProtected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="pt-32 text-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminProtected({ children }) {
  const { admin, ready } = useAuth();
  if (!ready) return <div className="pt-32 text-center text-zinc-500">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
